import {
  Box,
  Container,
  Heading,
  List,
  ListIcon,
  ListItem,
  Text,
  VStack,
} from '@chakra-ui/react'
import { FiAlertTriangle } from 'react-icons/fi'

export const TroubleshootingPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.500" mb={3}>
            ❓ Частые вопросы
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Быстрые решения самых распространённых ситуаций.
          </Text>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Не могу войти</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiAlertTriangle} color="orange.500" />Проверьте раскладку клавиатуры и правильность e-mail/пароля.</ListItem>
            <ListItem><ListIcon as={FiAlertTriangle} color="orange.500" />Используйте восстановление пароля на экране входа.</ListItem>
            <ListItem><ListIcon as={FiAlertTriangle} color="orange.500" />Если не помогает — обратитесь к администратору компании.</ListItem>
          </List>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Не вижу нужный раздел в меню</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiAlertTriangle} color="orange.500" />Скорее всего, в вашей роли нет прав на этот раздел.</ListItem>
            <ListItem><ListIcon as={FiAlertTriangle} color="orange.500" />Попросите руководителя/админа проверить вашу роль.</ListItem>
          </List>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Нет данных в графике или отчётах</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiAlertTriangle} color="orange.500" />Проверьте выбранный период и активные фильтры.</ListItem>
            <ListItem><ListIcon as={FiAlertTriangle} color="orange.500" />Проверьте, что по этому периоду есть созданные блоки работ.</ListItem>
          </List>
        </Box>
      </VStack>
    </Container>
  )
}
